import React, { useState, useEffect } from "react";
import { playIcon,certifiedIcon,exclamationIcon,videoCameraIcon, closeIcon, externalLink, videoIcon, importContentIcon, rssIcon, surveyIcon, codeIcon, clipBoardIcon, testIcon ,musicIcon,scorm} from "../../../constants/icons";
import LinkWrapper from "../../LinkWrapper";

function CoursePlaySlot({ className, courseTitle, courseTime, preview, lectureType, lectureName, videoId }) {
  const [modal, setModal] = useState(false);
  const [videoLoading, setVideoLoading] = useState(true);
  const [src, setSrc] = useState("");

  // useEffect(() => {
  //   if (lectureType == '4' || lectureType == '15'){
  //     setSrc(lectureName)
  //   }
  //   else{
  //     let current_url = window.location.origin
  //     let srcPreview = `${current_url}course/preview_video_lecture/${videoId}`
  //     setSrc(srcPreview)
  //   }

  // }, [lectureType]);

  const openModal = () => {
    if (lectureType == '4' || lectureType == '15') {
      setSrc(lectureName)
    }
    else {
      let current_url = window.location.origin
      let srcPreview = `${current_url}/course/preview_video_lecture/${videoId}`
      setSrc(srcPreview)
    }
    setModal(!modal);
  };
  const closeModal = () => {
    setModal(!modal);
  };

  const spinner = () => {
    setVideoLoading(!videoLoading);
  };

  const iconfn = (lectureType) => {
    let icon
    switch (lectureType) {
      case "1":
        icon = videoCameraIcon
        break;
      case "2":
        icon = importContentIcon
        // echo daysToMonth($course['cb_validity']);
        break;
      case "3":
        icon = testIcon
        break;
      case "4":
        icon = videoIcon
        break;
      case "5":
        icon = codeIcon
        break;
      case "7":
        icon = rssIcon
        break;
      case "8":
        icon = clipBoardIcon
        break;
      case "12":
        icon = musicIcon
        break;
      case "13":
        icon = surveyIcon
        break;
      case "14":
        icon = certifiedIcon
        break;
      case "18":
        icon = rssIcon
        break;
        case "16":
        icon = scorm
        break;
        case "15":
          icon = videoIcon
          break;
      default:
        icon = ""
        break;
    }
    return icon;
  }

  console.log(preview, "preview")
  return (
    <div className={`${className || ""} ${preview == "1" && "course-preview-slot"} d-flex justify-content-between `}>
      <LinkWrapper
        href="javascript:void(0);"
        className={`${preview == "1" ? "text-decoration-underline" : "text-decoration-none"} course-list`}
      >
        <div className="course-icon-title d-flex align-items-center gap-2">
          <span>{iconfn(lectureType)}</span>
          <p className="mb-0">{courseTitle}</p>
        </div>
      </LinkWrapper>
      {preview == 1 &&
        <div className="d-flex align-items-center gap-3">
          <LinkWrapper
            href="#"
            className={`${preview && "text-decoration-underline"} course-list d-flex justify-content-between`}
            onClick={openModal}
          >
            Preview
          </LinkWrapper>
          <span className="duration-play">{courseTime}</span>
        </div>
      }
      {modal ? (
        <section className="modal__bg">
          <div className="modal__align">
            <div className="modal__content" modal={modal}>
              <div
                className="modal__close"
                arial-label="Close modal"
                onClick={closeModal}>
                {closeIcon} Close
              </div>
              <div className="modal__video-align">
                {videoLoading ? (
                  <div className="modal__spinner">
                    <div
                      className="modal__spinner-style"
                      fadeIn="none">
                      {externalLink}
                    </div>
                  </div>
                ) : null}
                <iframe
                  className="modal__video-style"
                  onLoad={spinner}
                  loading="lazy"
                  width="800"
                  height="500"
                  src={src}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </section>
      ) : null}
    </div>
  );
}

export default CoursePlaySlot;
